import type { definitions } from '@luxuryescapes/contract-svc-accommodation'

import { mapAccommodationEnquirySession } from './accommodationEnquirySessionMap'
import { mapPropertyRate } from './propertyRatesMapper'

type ServerCheckoutEnquiryItem = definitions['CheckoutEnquiryItemResult']

/**
 * NB: no channel markup is applied. Checkout pricing is reconciled against `session.data.pricing`,
 * which is what svc-order charges, so uplifting the rate here would only desynchronise the
 * displayed breakdown from the charged total.
 *
 * `relations` on the mapped rate is always empty: it cross-references sibling rate ids, and a
 * checkout enquiry returns a single rate.
 */
export function mapCheckoutEnquiryItem(
  item: ServerCheckoutEnquiryItem,
): App.AccommodationCheckoutEnquiryItem {
  const session = mapAccommodationEnquirySession(item.session)
  return {
    sessionId: item.sessionId,
    outcome: item.outcome,
    session,
    originalSource: item.originalSource,
    ...(item.selectedSource ? { selectedSource: item.selectedSource } : {}),
    ...(item.rate
      ? { rate: mapPropertyRate(item.rate, undefined, session.data.currency, { [item.rate.id]: item.rate }) }
      : {}),
    ...(item.unavailableReason ? { unavailableReason: item.unavailableReason } : {}),
    ...(item.priceChange ? { priceChange: item.priceChange } : {}),
  }
}
